import { BusinessPremisesPresetEnum } from '@app/modules/business-premises/models/business-premises.model';
import { IOrganizationHttpParams }    from '@core/interfaces/api.interface';
import {
	AllowedDetailsTabEnum,
	ProductEnum
}                                     from '@core/interfaces/common.interfaces';
import {
	RouteBaseDefinition,
	RouteBasePath
}                                     from '@core/interfaces/route.interface';


export enum OrganizationRoutesEnum {
	ListPage = '',
	DetailPage = ':organizationId',
	FormPageCreate = 'create',
	FormPageUpdate = ':organizationId/update',
	UsagePage = ':organizationId/usage/:product/:usagePeriod',
	DetailPageTab = ':organizationId/:tab',
	DetailPageTabVariant = ':organizationId/:tab/:variant',
}

export interface OrganizationListPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Organizations;
	path: OrganizationRoutesEnum.ListPage;
	queryParams?: IOrganizationHttpParams;
}

export interface OrganizationDetailPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Organizations;
	path: OrganizationRoutesEnum.DetailPage;
	params: { organizationId: string };
}

export interface OrganizationFormPageCreateRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Organizations;
	path: OrganizationRoutesEnum.FormPageCreate;
}

export interface OrganizationFormPageUpdateRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Organizations;
	path: OrganizationRoutesEnum.FormPageUpdate;
	params: { organizationId: string };
}

export interface OrganizationUsagePageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Organizations;
	path: OrganizationRoutesEnum.UsagePage;
	params: {
		product: ProductEnum,
		organizationId: string,
		usagePeriod: string
	};
}

export interface OrganizationDetailPageTabRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Organizations;
	path: OrganizationRoutesEnum.DetailPageTab;
	params: { organizationId: string, tab: AllowedDetailsTabEnum };
	replaceLastStoredRouteWithNew: boolean;
}

export interface OrganizationDetailPageBusinessPremisesTabVariantRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Organizations;
	path: OrganizationRoutesEnum.DetailPageTabVariant;
	params: {
		organizationId: string;
		tab: AllowedDetailsTabEnum.ORGANIZATION_BUSINESS_PREMISES;
		variant: BusinessPremisesPresetEnum;
	};
	replaceLastStoredRouteWithNew: boolean;
}
